import React, { Ref } from 'react';

import Carousel from '../Carousel';
import MolLink from '../Menu/MolLink';
import { ProductCarouselModel } from './Model';

import './index.scss';

interface ProductCarouselProp {
  items: ProductCarouselModel[];
  title?: string;
  titlePosition?: 'center' | 'left';
  showTitle?: boolean;
}

export default class ProductCarousel extends React.Component<ProductCarouselProp> {
  clickTime: number;

  componentDidMount() {}

  componentWillUnmount() {}

  constructor(prop) {
    super(prop);
  }

  render() {
    let clickHandleCarousel = (
      dragChild: any,
      children: [],
      index: number,
      event: any,
    ) => {
      this.clickTime = Date.now();
      if (event.type == 'touchend') {
        let productid = this.props.items[index].products_id;
        window.historyHelper.memory.push('/product_info/' + productid);
      }
    };

    let stopClickHandler = (clickHandle: () => void) => {
      if (this.clickTime != NaN && this.clickTime != undefined) {
        let eventDifTime = Date.now() - this.clickTime;

        if (eventDifTime < 1000) {
          clickHandle();
        }
      }
    };

    let itemPadding = 50;
    let itemWidth = 200;

    let height = '250px';
    let imageHeigh = '250px';

    if (this.props.showTitle) {
      height = '315px';
    }

    return (
      <div className="productCarousel">
        {this.props.title != undefined ? (
          <h2 className={'productCarouselTitel ' + this.props.titlePosition}>
            {this.props.title}
          </h2>
        ) : null}
        <Carousel
          height={height}
          itemWidth={itemWidth}
          showMultiple={true}
          showDots={false}
          disableDrag={false}
          clickHandle={clickHandleCarousel}
          itemPadding={itemPadding}
        >
          {this.props.items != undefined
            ? this.props.items.map((item, index) => {
                return (
                  <MolLink
                    key={'apd_' + index}
                    to={'/product_info/' + item.products_id}
                    inlinePadding={false}
                    href={item.link}
                    stopClickHandler={stopClickHandler}
                  >
                    <div style={{ height: imageHeigh }}>
                      <img
                        src={
                          'https://media.moluna.de/images/bilder/' +
                          item.products_image
                        }
                      />
                      {this.props.showTitle ? (
                        <div className="titleContainer">
                          <div className="title">{item.bezeichnung}</div>
                          <div className="price">
                            {parseFloat(item.price + '').toFixed(2)} €
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </MolLink>
                );
              })
            : null}
        </Carousel>
      </div>
    );
  }
}
